/**
 * Width in css px of the fixed left menu strip when collapsed.
 *
 * What: the single source of truth for the menu width. `src/config/navBar.ts` re-exports it, so
 * existing `SHRUNK_WIDTH` imports keep working.
 * Why: `src/styles/portalLayout.ts` needs it to size the right page padding. Importing `navBar.ts`
 * there would pull in icons and lookup features, so this tiny file holds the value instead.
 * Constraint: on hover the menu expands OVER the page; the page layout width stays this value.
 */
export const SHRUNK_WIDTH = 56;
